import { combineReducers } from 'redux';
import { createReducer } from '@reduxjs/toolkit';

import favorites from './favorites';
import feed from './feed';
import forecast from './forecast';
import nearby from './nearby';
import overview from './overview';
import primarySpotId from './primarySpotId';
import subregionId from './subregionId';
import { setSubregionLoading } from '../../actions/subregion';

export default combineReducers({
  favorites,
  feed,
  forecast,
  nearby,
  overview,
  primarySpotId,
  subregionId,
  loading: createReducer(false, (builder) => {
    builder.addCase(setSubregionLoading, (state, action) => action.payload);
  }),
});
